<div class="modal-header" appCustomAutofocus>
    <h3 class="modal-title">Distribute {{mode === 'C' ? 'Checklists' : 'Action Items'}}</h3>
</div>
<div class="modal-body">
    <div class="col-md-12">
        <div class="alert" *ngIf="alert != null" [ngClass]="{'alert-success' : alert.type === 'success', 'alert-default' : alert.type === 'default', 'alert-danger': alert.type === 'danger' }" role="alert">
            {{alert.msg}}
            <button type="button" class="close" (click)="closeAlert()">
                <i class="modus-icons">close</i>
            </button>
        </div>
    </div>

    <form #notificationForm="ngForm">
        <div class="row" style="margin-bottom:10px;">
            <div class="col-lg-2">
                <label><strong>To:</strong></label>
            </div>
            <div class="col-lg-10">
                <app-auto-complete-email style="margin-bottom:10px;"
                                         name="email"
                                         [dropDownList]="emailList"
                                         [(model)]="formData.ToEmail"
                                         [(disable)]="emailSendWait">
                </app-auto-complete-email>
            </div>
        </div>

        <div class="row" style="margin-bottom:10px;">
            <div class="col-lg-2">
                <label><strong>Subject:</strong></label>
            </div>
            <div class="col-lg-10">
                <input type="text" name="subject" class="form-control"
                       [(ngModel)]="formData.Subject" [required]="true" [disabled]="emailSendWait" />
            </div>
        </div>
        <div class="row" style="margin-bottom:10px;">
            <div class="col-lg-2">
                <label><strong>Message:</strong></label>
            </div>
            <div class="col-lg-10">
                <textarea class="form-control" name="message" style="max-height:500px;max-width:460px;"
                          [(ngModel)]="formData.Message" [required]="true" [disabled]="emailSendWait"></textarea>
            </div>
        </div>
        <div class="row" style="margin-bottom:10px;">
            <div class="col-lg-4">
                <label><strong>Attachments</strong></label><br />
                <div *ngFor="let checklist of checklists">
                    <a href='/Checklist/GetChecklist?checklistInstanceID={{checklist["ChecklistInstanceID"]}}&fileName={{checklist.Filename}}&templateID={{checklist.ChecklistTemplateID}}'>
                        {{checklist.Filename}}
                    </a>
                </div>
            </div>

        </div>
        <div>
            <label><strong>Additional Attachments</strong></label><br />
            <div class="row">
                <div class="col-lg-4 col-md-4">
                    <div ngfDrop
                         name="attachments"
                         multiple="1"
                         selectable="1"
                         [(validDrag)]="validComboDrag"
                         [(files)]="formData.fileDrop"
                         accept=".pdf,.jpg,.jpeg,.gif,.tif,.tiff,.png,.bmp,.doc,.docx,.xls,.xlsx,.ppt,.pps,.pptx,.ppsx,.sldx"
                         [(dragFiles)]="dragFiles"
                         class="drop-box"
                         [class.invalid-drag]="validComboDrag===false"
                         [class.valid-drag]="validComboDrag"
                         (filesChange)="upload()" [ngfFixOrientation]="false">
                        Drop a file or Click to upload
                    </div>
                </div>
                <div class="col-lg-8 col-md-8">
                    <div *ngFor="let file of newFiles" style="margin-bottom: 5px; word-break: break-word;">
                        {{file.Filename}}
                        <a class="button-link" style="color: red;cursor: pointer;" (click)="deleteAttachment(file)" *ngIf="file.File != null && file.Progress == null" [disabled]="emailSendWait">Remove</a>
                        <div style="padding-left:15px;margin-top:5px;">
                            <div class="progress" style="width:300px;" *ngIf="file.Progress > 0 && file.Progress < 100">
                                <div class="progress-bar" role="progressbar" [ngStyle]="{ 'width': file.Progress + '%' }">{{file.Progress}}%</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>

<div class="modal-footer">
    <div [hidden]="!emailSendWait"><img src="/Cache/images/icon_load.gif" alt="Loading..." style="margin-bottom:10px;" /></div>
    <button type="button" class="btn btn-primary" (click)="sendClicked()" [disabled]="notificationForm.form.invalid || formData.ToEmail.length < 1 || emailSendWait">Send</button>
    <button type="button" class="btn btn-outline-dark" (click)="closeClicked()" [disabled]="emailSendWait">Close</button>
</div>